module.exports = __webpack_public_path__ + "img/group4.e2f33a95.png";